// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__0vUkE","font":"styles_font__bJuxo"};